import { actionSpinnerClose, actionSpinnerOpen } from '@qadra/frontend-common/redux/actions';
import { call, takeEvery, put } from '@qadra/frontend-common/redux-saga';
import { LOGIN } from '../actions';
import { apiLoginPost } from '../api';

function* login({ payload }) {
  try {
    yield put(actionSpinnerOpen());

    const { returnUrl, error } = yield call(apiLoginPost, payload);

    if (error) {
      yield put({
        type: LOGIN._ERROR,
        error,
      });
      yield put(actionSpinnerClose());
    } else {
      window.location.href = returnUrl || '';
    }
  } catch (error) {
    yield put({
      type: LOGIN._ERROR,
      error,
    });
    yield put(actionSpinnerClose());
  }
}

function* watchLogin() {
  yield takeEvery(LOGIN._REQUEST, login);
}

const array = [watchLogin];
export default array;
